<template>
<div>
  <el-dialog
    :visible='visible'
    :beforeClose='close'
    :close-on-click-modal='false'
    :title='rawTitle || (title ? t(title) : "")'
    :width='width'
  >
    <hs-form ref='form' :formData='form' :rules='rules'/>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ t('cancel') }}</el-button>
      <el-button type="primary" @click="save" :loading='loading'>{{ t('confirm') }}</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import HsForm from '../form'
import Locale from '../../mixins/locale'

export default {
  name: 'HsFormDialog',

  components: {
    HsForm
  },

  mixins: [Locale],

  props: {
    /**
     * 弹窗宽度
     */
    width: String,
    /**
     * 弹窗标题（不会进行国际化）
     */
    rawTitle: String,
    /**
     * 弹窗标题（会进行国际化）
     */
    title: {
      type: String,
      default: 'Title'
    },
    /**
     * 弹框显示与否
     */
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * 表单对象
     */
    form: Array,
    /**
     * 表单校验规则
     */
    rules: Object,
    /**
     * 按钮loading状态
     */
    loading: Boolean
  },

  methods: {
    save () {
      if (this.loading) return
      this.$refs.form.validate(valid => {
        if (valid) {
          const formData = this.$refs.form.getFormModel()
          /**
           * 保存事件
           */
          this.$emit('save', formData)
        }
      })
    },

    close () {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style>

</style>